import { Image, PortableText, TypeWrapper } from '@ahmdigital/ui';
import { isArray, isPlainObject } from 'lodash/fp';

import { SectionOfferStrip } from '../../../../../insurance/types';
import getFootnoteSerializer from '../../../../../../utils/get-footnote-serializer';
import insertFootnoteReference from '../../../../../../utils/insert-footnote-reference';
import offerTagImage from '../../../../../../components/offers/images/offer-tag.svg';
import styles from './styles.module.sass';

type Props = {
  offer: SectionOfferStrip;
};

const OfferTongue = ({ offer }: Props) => {
  const offerTitle = offer?.title;
  const offerFootnote = offer?.footnote;
  return (
    <div className={styles.offerTongueWrapper}>
      <Image className={styles.offerTag} src={offerTagImage.src} alt="Offer" />
      <TypeWrapper className={styles.offerCopy} variant="simpleBit">
        <PortableText
          source={insertFootnoteReference({
            footnote: offerFootnote,
            isPortableText: isPlainObject(offerTitle) || isArray(offerTitle),
            text: offerTitle,
          })}
          typeSerializers={getFootnoteSerializer({ footnote: offerFootnote, variant: 'footnote' })}
        />
      </TypeWrapper>
    </div>
  );
};

export default OfferTongue;
